<template>
  <v-layout v-if="taxi" pl-2 pt-4 pr-2 pb-2 justify-center row>
    <v-flex xs12 sm10 md9 lg7 pl-2>
      <SimpleCard>
        <v-layout row wrap>
          <v-flex xs12>
            <h3>
              Edit Taxi
              <b>{{ taxi.registration_number }}</b>
            </h3>
          </v-flex>
          <v-flex xs12 md12>
            <TaxiForm
              ref="taxiForm"
              :disabled="false"
              :taxi="taxi"
              :errors="errors"
              :rideTypes="rideTypes"
              :councils="councils"
              @validityChange="updateFormValidity($event)"
            />
          </v-flex>
          <v-flex xs12 md12>
            <v-layout align-center justify-end row>
              <v-btn color="success" @click="submit" class="text-none">Update</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </SimpleCard>
    </v-flex>
    <v-snackbar v-model="snackbarShow" :color="snackbarColour" :timeout="4000">{{ snackbarMessage }}</v-snackbar>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
//TODO change directory of taxi form
import TaxiForm from "@/components/driver/TaxiForm.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "edit_taxi",
  components: {
    SimpleCard,
    TaxiForm
  },
  data: function() {
    return {
      rideTypes: null,
      taxi: null,
      councils: null,
      errors: {},
      formValid: false,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null
    };
  },
  mounted: async function() {
    this.getTaxi();
  },
  methods: {
    submit: function() {
      let self = this;
      let url = `${this.$store.state.apiUrl}/taxi/${this.taxi.id}/update`;

      if (this.formValid) {
        axios({
          url: url,
          method: "post",
          data: {
            user: this.user,
            driver: this.driver,
            driver_details: this.driver_details,
            taxi: this.taxi,
            pictureUrl: this.pictureUrl,
            currentDocuments: this.currentDriverDocuments
          },
          headers: {
            "Content-Type": "text/plain"
          }
        })
          .then(function(response) {
            if (response.data.errors) {
              self.errors = response.data.errors;
              self.snackbarMessage =
                "Error updating taxi, please check the form";
              self.snackbarColour = "error";
              self.snackbarShow = true;
            } else if (response.data.error != "no_error") {
              self.snackbarMessage =
                "Error updating taxi: " + response.data.error;
              self.snackbarColour = "error";
              self.snackbarShow = true;
              console.log(response.data.error);
            } else {
              const taxiID = response.data.taxi.id;
              self.$router.push("../../taxi/edit/" + taxiID);
            }
          })
          .catch(function(error) {
            console.log(error);
            self.snackbarMessage = error;
            self.snackbarColour = "error";
            self.snackbarShow = true;
          });
      } else {
        this.snackbarMessage = "Please complete the form before submitting";
        this.snackbarColour = "error";
        this.snackbarShow = true;
        this.$refs.taxiForm.validateForm();
      }
    },
    getTaxi: async function() {
      this.loading = true;
      try {
        var url = `${this.$store.state.apiUrl}/taxi/${this.$route.params.id}/get`;
        let response = await axios.get(url, {
          params: {}
        });

        this.taxi = response.data.taxi;
        this.rideTypes = response.data.ride_types;
        this.councils = response.data.councils;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get driver " + error);
      }
    },
    updateFormValidity: function(value) {
      this.formValid = value;
    }
  }
};
</script>
